type Props = {
  percent: number;
  label?: string;
  sublabel?: string;
  className?: string;
  compact?: boolean;
};

export function Phase1ProgressBar({
  percent,
  label = "Overall progress",
  sublabel,
  className = "",
  compact = false,
}: Props) {
  const pct = Math.max(0, Math.min(100, Math.round(percent)));
  const showHeader = Boolean(label);
  return (
    <div className={className}>
      {showHeader ? (
        <div
          className={`flex justify-between text-on-surface-variant mb-1 ${
            compact ? "text-[10px]" : "text-xs"
          }`}
        >
          <span>{label}</span>
          <span>{pct}%</span>
        </div>
      ) : null}
      <div
        className={`bg-surface-variant rounded overflow-hidden ${
          compact ? "h-1.5" : "h-2.5"
        }`}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      {sublabel ? (
        <p
          className={`mt-1 text-on-surface-variant truncate ${
            compact ? "text-[10px] font-data-mono" : "text-xs font-data-mono"
          }`}
        >
          {sublabel}
        </p>
      ) : null}
    </div>
  );
}
